import { bootFrontend } from '../shared/bootstrap';

bootFrontend();
